<template>
   <div class="col-md-12">
      <div class="title-heading d-flex justify-content-between">
         <h1>{{ $static('landings.title', 'Налаштування Лендінгів') }}</h1>
      </div>

      <div class="default-cards-list minimal-list">
         <div class="default-cards-top">
            <div class="name name-category">{{ $static('landings.name', 'Назва лендінгу') }}</div>
            <div class="name name-actions">{{ $static('s-p.actions', 'Редагувати') }}</div>
         </div>

         <!-- Элемент если лэндингов нет -->
         <div class="default-card-layout"
            v-if="(!landings || !Array.isArray(landings) || landings.length === 0) && !isLoading">
            <div class="default-card-content">
               <div class="default-card-main">
                  <div class="default-card-title">{{ $static('landings.no-landings', 'Лендінги вісутні') }}</div>
               </div>
               <div class="actions-box">
               </div>
            </div>
         </div>
         <!-- .------------------------- -->

         <!--Список лэндингов -->
         <div class="default-card-layout" v-for="(landing, landingIndex) in landings" :key="landingIndex"
            style="cursor: pointer">
            <div class="default-card-content">
               <div class="default-card-main">
                  <div class="default-card-title">{{ $dynamic(landing, landing.text, 'text') }}</div>
               </div>
               <div class="actions-box">
                  <Popper arrow :content="$static('iconsbtn.edit', 'Редагувати')" hover placement="top"
                     style="white-space: nowrap">
                     <button class="btn-icon btn-rounded btn-icon-transparent editor_trigger"
                        title="{{$static('iconsbtn.edit', 'Редагувати')}}" @click="openEditor(landing)">
                        <span class="icon icon-edit"></span>
                     </button>
                  </Popper>
                  <Popper arrow :content="$static('iconsbtn.delete', 'Видалити')" hover placement="top"
                     style="white-space: nowrap">
                     <button class="btn-icon btn-rounded btn-icon-transparent order_edit"
                        @click.prevent.stop="openRemoveConfirmationModal(landing)">
                        <span class=" icon icon-trash"></span>
                     </button>
                  </Popper>
               </div>
            </div>
         </div>
         <!-- .------------------------- -->
         <!--Кнопка добавления лэндингов -->
         <div class="default-card-layout" style="cursor: pointer" @click="openEditor(emptyLanding)">
            <div class="default-card-content">
               <div class="default-card-main">
                  <div class="default-card-title">{{ $static('s-o.btn-add', 'Додати') }}
                     <span class="icon icon-add"></span>
                  </div>
               </div>
            </div>
         </div>
         <!-- .------------------------- -->
      </div>
   </div>

   <Teleport to="body">
      <!-- EDITOR WRAPPER for other pages-->
      <div class="overlay-editor landing-editor">
         <div class="overlay-editor-wrapper" v-if="selected">
            <div class="panel-top">

               <div class="lang-selector-holder d-flex align-items-center">
                  <label v-if="langs && langs.length > 1" class="custom-label">{{ $static('ei.tr', 'Переклад на:')
                     }}</label>
                  <LangSelector v-model="lang" />
               </div>

               <a href="javascript:void(0);" class="back_trigger" @click="closeLandingEditor">
                  <span class="icon icon-cross"></span>
               </a>
            </div>
            <LandingEditor :landingData="selected" @cancel="closeLandingEditor" @save="saveLanding" :lang="lang">
            </LandingEditor>

         </div>
      </div>
      <!--END EDITOR WRAPPER for other pages-->
   </Teleport>

   <Teleport to="body">
      <div class="remove-order-confirmation-modal">
         <div class="modal-dialog modal-dialog-centered d-flex align-items-center" style="height:90%" role="document">
            <div class="modal-content w-100">
               <div class="modal-header modal-header-noborder">
                  <button type="button" class="close" @click.prevent="closeRemoveConfirmationModal">
                     <span class="icon icon-cross"></span>
                  </button>
               </div>
               <div class="modal-body">
                  <h2 style="text-align: center">{{ $static('landings.remove-modal-title', 'Видалення лендінгу') }}</h2>
                  <div class="modal-text text-center">
                     <p><strong>{{ $static('landings.remove-are-you-sure',
                        'Ви впевнені, що хочете видалити лендінг?') }}</strong></p>
                  </div>
                  <div class="button-holder button-holder-center-container">
                     <button class="transparent-btn default-btn" @click="closeRemoveConfirmationModal">
                        <span class="text">{{ $static('order.delete-cancel-btn', 'Відмінити') }}</span>
                     </button>
                     <button class="default-btn btn-remove" @click="remove()">
                        <span class="text">{{ $static('order.modal-delete-btn', 'Видалити') }}</span>
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </Teleport>
</template>

<script>
import LandingEditor from '../components/LandingEditor';
import LangSelector from '../components/LangSelector';
import api from '@/api';

export default {
   name: 'Landings',
   components: { LangSelector, LandingEditor },
   data() {
      return {
         lang: '',
         selected: undefined,
         emptyLanding: {
            url: "",
            tags: "",
            text: "",
            content: "",
            // content: { html: "", css: "" },
            order: this.landings?.length || 0,
            parent: null,
            hidden: false,
            translate: {},

         },
         landings: [],

         isLoading: false,
      }
   },
   async mounted() {
      await this.getLandings();
   },

   computed: {
      langs() {
         return this.$store.getters.settings
            && this.$store.getters.settings.public
            && this.$store.getters.settings.public.lang
            && Array.isArray(this.$store.getters.settings.public.lang) ?
            this.$store.getters.settings.public.lang : []
      },
   },

   methods: {
      async getLandings() {
         if (this.isLoading) {
            return;
         }

         this.isLoading = true;

         try {
            const response = await api.get('/api/pages');
            this.landings = response.data.result;

         } catch (error) {
            console.error('Ошибка при получении данных о лэндингах:', error);
         } finally {
            this.isLoading = false;
         }
      },

      closeLandingEditor() {
         this.selected = undefined;

         window.$('body').removeClass('is-hidden');
         window.$('.back-blur').removeClass('active');
         window.$('.overlay-editor.landing-editor').removeClass('active');

         //Возвращаем взад удаленного в SettingsModalBox слушателя, который нам мешал, но используется в функционале нашего ресурса.
         window.$('.back-blur').off('click');

         window.$('.back-blur').on('click', function () {
            window.$('body > .active').removeClass('active');
            window.$('body').removeClass('is-hidden');
         });
      },

      async openEditor(item) {
         this.selected = item;

         this.isLoading = true;

         try {
            if (this.selected && this.selected.id !== null && this.selected.id !== undefined) {

               const resp = await api.post('/api/page/find', { id: this.selected.id });
               this.selected = resp.data.result;
            } else {
               this.selected = this.emptyLanding;
            }
         } catch (error) {
            this.selected = undefined;
            console.error('Error opening landing:', error);
            this.$notify({
               title: this.$static('notify.error-title', 'Помилка'),
               text: this.$static('landings-opening-error', 'Помилка при відкритті лендінгу'),
               type: 'error',
               duration: 3000
            });
         } finally {
            this.isLoading = false;
         }
         window.$('.back-blur').off('click'); // удаляем слушатель события клика на бэк-блюр поставленный в AdminBox. Он визуально скрывает модальное окно слишком рано - до момента сохранения данных и или их обновления.
         window.$('.back-blur').on('click', () => this.closeLandingEditor());

         window.$('.filter_sidebar').removeClass('active');
         window.$('body').addClass('is-hidden');
         window.$('.back-blur').addClass('active');
         window.$('.overlay-editor.landing-editor').addClass('active');
      },

      async saveLanding(landing) {
         if (this.isLoading) {
            return;
         }

         this.isLoading = true;

         try {
            let resp;
            // if (this.selected && this.selected.id === null && this.selected.id === undefined) {
            //    resp = await api.post('/api/page', landing);
            // } else {
            //    resp = await api.post('/api/page/find', { id: this.selected.id, ...landing });
            //    resp = await api.post('/api/page', landing);
            // 
            // }
            resp = await api.post('/api/page', landing);
            const data = resp.data;

            if (data) {
               this.$notify({
                  title: this.$static('notify.landing-title', 'Лендінг'),
                  text: this.$static('notify.save', 'Збережено.'),
                  duration: 1000
               });
            }
            this.isLoading = false;
            await this.getLandings();
            this.closeLandingEditor();

         } catch (error) {
            console.error('Error saving landing:', error);
            this.$notify({
               title: this.$static('notify.error-title', 'Помилка'),
               text: this.$static('notify.error', 'Помилка при збереженні данних.'),
               type: 'error',
               duration: 3000
            });
         } finally {
            this.isLoading = false;
         }
      },

      openRemoveConfirmationModal(item) {
         this.selected = item;
         window.$('body').addClass('is-hidden');
         window.$('.back-blur').toggleClass('active');
         window.$('.remove-order-confirmation-modal').toggleClass('active');
      },

      closeRemoveConfirmationModal() {
         this.selected = undefined;
         window.$('body').removeClass('is-hidden');
         window.$('.back-blur').removeClass('active');
         window.$('.remove-order-confirmation-modal').removeClass('active');
      },

      async remove() {
         try {
            await api.delete('/api/page/' + this.selected.id);
            await this.getLandings();

            this.$notify({
               title: this.$static('landings.remove-landing-title', 'Видалення лендінгу'),
               text: this.$static('landings.success-remove-text1', 'Лендінг') + `${this.selected.text}` + this.$static('landings.success-remove-text2', ' видалено успішно'),
               duration: 2000
            });

            this.selected = undefined;

            this.closeRemoveConfirmationModal();
         } catch (error) {
            console.error('Error removing order:', error);
            this.$notify({
               title: this.$static('notify.error-title', 'Помилка'),
               text: this.$static('landings.remove-error-text', 'Сталася помилка при видаленні лендінгу'),
               type: 'error',
               duration: 3000
            });
         }
      },
   }
}
</script>

<style scoped>
.remove-order-confirmation-modal {
   position: fixed;
   top: 50%;
   left: 50%;
   /* transform: translate(-50%, -50%); */
   z-index: 10000;
   opacity: 0;
   visibility: hidden;
   transition: all .2s cubic-bezier(.165, .84, .44, 1);
   -webkit-transition: all .2s cubic-bezier(.165, .84, .44, 1);
   transition-delay: 0s;

   &.active {
      opacity: 1;
      visibility: visible;
      -webkit-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
      transition: all .2s cubic-bezier(.165, .84, .44, 1);
      -webkit-transition: all .2s cubic-bezier(.165, .84, .44, 1);
   }

   .modal-header-noborder {
      border-bottom: none;
   }

   .button-holder-center-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 20px;
   }
}
</style>